import styled from 'styled-components'
import { DARK, GREEN } from '../../utils/colors'
import { SM } from '../../utils/screenSizes'

export const Container = styled.div`
  padding-top: 89px;
  color: ${DARK};
  display: flex;

  transition: ease-in-out all 0.6s;

  a {
    color: ${GREEN};
  }

  .faq_content {
    flex: 1;
    margin-right: 46px;
    font-size: 16px;
    line-height: 27px;

    &.closed {
      .faq_content__response {
        max-height: 0;
      }
      .faq_content__title {
        transition: ease-in-out all 0.2s;
        margin-bottom: 0px;
      }
    }
  }

  .faq_content__response {
    @media (max-width: ${SM}) {
      margin-right: -90px;
    }

    transition: ease-in-out all 0.2s;
    max-height: 500px;
    overflow: hidden;
  }

  .faq_content__title {
    cursor: pointer;
    font-family: Mont;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 41px;
    margin-bottom: 41px;
  }

  button {
    transition: ease-in-out all 0.2s;
    opacity: 0.2;
    width: 45px;
    height: 45px;
    background: transparent;
    border: none;
    display: flex;
    padding: 10px;

    &.closed {
      transform: rotate(-180deg);
    }

    img {
      width: 100%;
    }
  }
`
